<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <vc-layout :spacing="16" :class="['nav-drawer-demos']" v-resize="resize">
      <vc-col :span="12" sm24>
        <example-title src="example-1.html" title="Collapsed" />
        <div :class="['device', 'elevation-8']">
          <div>
            <vc-toolbar>
              <vc-toolbar-icon-left icon="menu" @click="nav1 = !nav1" />
              <vc-toolbar-title>App</vc-toolbar-title>
              <vc-toolbar-controls-right>
                <vc-button v-for="i in 3" :key="i" icon-button color="transparent">
                  <vc-icon>{{ icons[i] }}</vc-icon>
                </vc-button>
              </vc-toolbar-controls-right>
            </vc-toolbar>
            <vc-nav-drawer v-model="nav1" :temporary="false" :dark="false" :width="navWidth">
              <vc-collapsible name="collapsible-1" color="primary" :multiple="false">
                <vc-collapsible-item v-for="j in 5" :open="j === 2" :key="j" :label="`Item ${j}`" has-vc-list :icon="icons[j]">
                  <vc-list>
                    <vc-list-item v-for="i in 5" :key="i" :avatar="`/static/images/avatar-0${i}.png`" :icon="icons[i]">
                      <vc-list-item-primary-text>User {{ i }}</vc-list-item-primary-text>
                      <vc-list-item-secondary-text>{{ icons[i] }}</vc-list-item-secondary-text>
                    </vc-list-item>
                  </vc-list>
                </vc-collapsible-item>
              </vc-collapsible>
            </vc-nav-drawer>
            <vc-layout :spacing="16">
              <vc-col :span="24" :class="['device-content']">
                <vc-lorem-ipsum :repeats="4" />
              </vc-col>
            </vc-layout>
          </div>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-2.html" title="Expanded, right" />
        <div :class="['device', 'elevation-8']">
          <div>
            <vc-toolbar color="green">
              <vc-toolbar-controls-left>
                <vc-button v-for="i in 3" :key="i" icon-button color="transparent">
                  <vc-icon>{{ icons[i] }}</vc-icon>
                </vc-button>
              </vc-toolbar-controls-left>
              <vc-toolbar-title :class="['align-right']">App</vc-toolbar-title>
              <vc-toolbar-icon-right icon="menu" @click="nav2 = !nav2" />
            </vc-toolbar>
            <vc-nav-drawer v-model="nav2" :temporary="false" :dark="false" right :width="navWidth">
              <vc-collapsible name="collapsible-2" color="green" :multiple="false">
                <vc-collapsible-item v-for="j in 5" :open="j === 2" :key="j" :label="`Item ${j}`" has-vc-list :icon="icons[j]">
                  <vc-list>
                    <vc-list-item v-for="i in 5" :key="i" :avatar="`/static/images/avatar-0${i}.png`" :icon="icons[i]">
                      <vc-list-item-primary-text>User {{ i }}</vc-list-item-primary-text>
                      <vc-list-item-secondary-text>{{ icons[i] }}</vc-list-item-secondary-text>
                    </vc-list-item>
                  </vc-list>
                </vc-collapsible-item>
              </vc-collapsible>
            </vc-nav-drawer>
            <vc-layout :spacing="16">
              <vc-col :span="24" :class="['device-content']">
                <vc-lorem-ipsum :repeats="4" />
              </vc-col>
            </vc-layout>
          </div>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-3.html" title="Temporary, collapsed" />
        <div :class="['device', 'elevation-8']">
          <div>
            <vc-toolbar color="pink">
              <vc-toolbar-icon-left icon="menu" @click="nav3 = !nav3" />
              <vc-toolbar-title>App</vc-toolbar-title>
              <vc-toolbar-controls-right>
                <vc-button v-for="i in 3" :key="i" icon-button color="transparent">
                  <vc-icon>{{ icons[i] }}</vc-icon>
                </vc-button>
              </vc-toolbar-controls-right>
            </vc-toolbar>
            <vc-nav-drawer v-model="nav3" :temporary="true" :dark="false" :width="navWidth">
              <vc-collapsible name="collapsible-3" color="pink" :multiple="false">
                <vc-collapsible-item v-for="j in 5" :open="j === 2" :key="j" :label="`Item ${j}`" has-vc-list :icon="icons[j]">
                  <vc-list>
                    <vc-list-item v-for="i in 5" :key="i" :avatar="`/static/images/avatar-0${i}.png`" :icon="icons[i]">
                      <vc-list-item-primary-text>User {{ i }}</vc-list-item-primary-text>
                      <vc-list-item-secondary-text>{{ icons[i] }}</vc-list-item-secondary-text>
                    </vc-list-item>
                  </vc-list>
                </vc-collapsible-item>
              </vc-collapsible>
            </vc-nav-drawer>
            <vc-layout :spacing="16">
              <vc-col :span="24" :class="['device-content']">
                <vc-lorem-ipsum :repeats="4" />
              </vc-col>
            </vc-layout>
          </div>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-4.html" title="Temporary, expanded, right" />
        <div :class="['device', 'elevation-8']">
          <div>
            <vc-toolbar color="deep-purple">
              <vc-toolbar-controls-left>
                <vc-button v-for="i in 3" :key="i" icon-button color="transparent">
                  <vc-icon>{{ icons[i] }}</vc-icon>
                </vc-button>
              </vc-toolbar-controls-left>
              <vc-toolbar-title :class="['align-right']">App</vc-toolbar-title>
              <vc-toolbar-icon-right icon="menu" @click="nav4 = !nav4" />
            </vc-toolbar>
            <vc-nav-drawer v-model="nav4" :temporary="true" :dark="false" right :width="navWidth">
              <vc-collapsible name="collapsible-4" color="deep-purple" :multiple="false">
                <vc-collapsible-item v-for="j in 5" :open="j === 2" :key="j" :label="`Item ${j}`" has-vc-list :icon="icons[j]">
                  <vc-list>
                    <vc-list-item v-for="i in 5" :key="i" :avatar="`/static/images/avatar-0${i}.png`" :icon="icons[i]">
                      <vc-list-item-primary-text>User {{ i }}</vc-list-item-primary-text>
                      <vc-list-item-secondary-text>{{ icons[i] }}</vc-list-item-secondary-text>
                    </vc-list-item>
                  </vc-list>
                </vc-collapsible-item>
              </vc-collapsible>
            </vc-nav-drawer>
            <vc-layout :spacing="16">
              <vc-col :span="24" :class="['device-content']">
                <vc-lorem-ipsum :repeats="4" />
              </vc-col>
            </vc-layout>
          </div>
        </div>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'PageNavDrawer',
  data () {
    return {
      title: null,
      description: null,
      nav1: false,
      nav2: true,
      nav3: false,
      nav4: true,
      navWidth: 300,
      icons: ['home', 'schedule', 'account_circle', 'audiotrack', 'beenhere', 'camera']
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  },
  methods: {
    resize () {
      if (this.viewport().width <= 480) {
        this.navWidth = 220
        return
      }
      this.navWidth = 300
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/nav-drawer.vue